<template>
    <v-layout column class="member-further-security">
        <v-flex xs12 class="member-further-security__subtitle">
            {{loginConstants.ADDITIONAL_SECURITY_NEEDED_SUBTITLE}}
        </v-flex>
        <v-flex xs12 class="member-further-security__form">
            <v-form v-model="valid" ref="memberFurtherSecurity">
                <v-layout row align-content-start justify-start>
                    <v-flex mr-2 xs4>
                        <v-text-field id="country_code_input"
                                      data-qe-id="login_further-security_country-code_input"
                                      name="countryCode"
                                      autofocus
                                      :placeholder="loginConstants.COUNTRY_CODE"
                                      v-model="memberFurtherSecurityDetails.countryCode"
                                      :rules="countryCodeRules"
                                      :disabled="isSubmitting"
                                      :maxlength="loginConstants.MAXIMUM_LENGTH_FOR_COUNTRY_CODE"
                                      :onkeyup="resetError()"
                                      required
                                      v-on:keydown.enter.prevent>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs8>
                        <v-text-field id="phone_number_input"
                                      data-qe-id="login_further-security_phone-number_input"
                                      name="phoneNumber"
                                      :placeholder="loginConstants.PHONE_NUMBER"
                                      v-model="memberFurtherSecurityDetails.phoneNumber"
                                      :maxlength="loginConstants.MAXIMUM_LENGTH_FOR_PHONE_NUMBER"
                                      :rules="phoneNumberRules"
                                      :disabled="isSubmitting"
                                      :onkeyup="resetError()"
                                      required
                                      v-on:keydown.enter.prevent>
                        </v-text-field>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-flex>
        <login-error></login-error>
        <v-card-actions>
            <v-layout row wrap pt-3>
                <v-btn flat
                       large
                       id="return_to_home_btn"
                       data-qe-id="return_to_home_btn"
                       block
                       class="ypo_blue--text"
                       @click="returnToMainPage()"
                       :disabled="isSubmitting">
                    {{loginConstants.CANCEL}}
                </v-btn>
                <v-btn id="login_further-security_submit_btn"
                       data-qe-id="login_further-security_submit_btn"
                       color="ypo_blue"
                       class="white--text"
                       @click="submit"
                       :disabled="!canSave"
                       large
                       block>
                    {{loginConstants.SUBMIT}}
                </v-btn>
            </v-layout>
        </v-card-actions>
    </v-layout>
</template>
<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex';
    import { storeGetters } from "../../../store/storeGetters.constant";
    import { storeAction } from "../../../store/storeActions.constant";
    import { loginConstants } from '../login.constants';
    import LoginError from "../LoginError";
    import { additionalSecurityForMember } from "../../../store/store.constant";
    import { storeMutation } from "../../../store/storeMutations.constant";

    export default {
        name: 'FurtherSecurity',
        components: { LoginError },
        data: () => ({
            loginConstants,
            valid: false,
            error: '',
            componentNames: loginConstants.componentNames,
            numberOfAttempts: 0,
            countryCodeRules: [
                v => !!v || loginConstants.errors.COUNTRY_CODE_REQUIRED,
                v => !!v.match(/^\d+$/) || loginConstants.errors.COUNTRY_CODE_TYPE_ERROR,
            ],
            phoneNumberRules: [
                v => !!v || loginConstants.errors.PHONE_NUMBER_REQUIRED,
                v => !!v.match(/^[a-zA-Z0-9\-.()\s]+$/) || loginConstants.errors.PHONE_NUMBER_TYPE_ERROR,
            ],
        }),
        props: {
            changeCardState: Function,
            toggleProgressIndicator: Function,
            isSubmitting: Boolean,
            returnToLogin: Function,
        },
        methods: {
            ...mapActions({
                submitPasswordFurtherSecurityForMember: `auth/${storeAction.submitPasswordFurtherSecurityForMember}`,
                clearErrorOnStateChange: `auth/${storeAction.handleLoginErrorMessage}`,
            }),
            ...mapMutations({
                updateAdditionalSecurityObjectInState: `auth/${storeMutation.prepareAdditionalSecurityObjectForPassword}`,
            }),
            submit() {
                this.toggleProgressIndicator();
                if (this.$refs.memberFurtherSecurity.validate()) {
                    this.numberOfAttempts += 1;
                    this.submitPasswordFurtherSecurityForMember(this.memberFurtherSecurityDetails)
                        .then((resp) => {
                            this.toggleProgressIndicator();
                            if (resp.data && resp.data.duplicateUserFound) {
                                this.changeCardState(this.componentNames.contactUsForFurtherAssistance.component);
                            } else {
                                this.changeCardState(this.componentNames.selectTypePasswordDelivery.component);
                            }
                        })
                        .catch(() => {
                            this.toggleProgressIndicator();
                            if (this.numberOfAttempts === loginConstants.MAXIMUM_ATTEMPTS_FOR_ADDITIONAL_SECURITY) {
                                this.updateAdditionalSecurityObjectInState(additionalSecurityForMember());
                                this.changeCardState(this.componentNames.contactUsForFurtherAssistance.component);
                            }
                        });
                }
            },
            resetError() {
                if (!this.memberFurtherSecurityDetails.countryCode || !this.memberFurtherSecurityDetails.phoneNumber) {
                    this.clearErrorOnStateChange(null);
                }
            },
            returnToMainPage() {
                this.updateAdditionalSecurityObjectInState(additionalSecurityForMember());
                this.returnToLogin();
            },
        },
        computed: {
            ...mapGetters({
                memberFurtherSecurityDetails: `auth/${storeGetters.getMemberAdditionalSecurityObject}`,
            }),
            canSave() {
                return this.memberFurtherSecurityDetails && !!this.memberFurtherSecurityDetails.countryCode
                    && !!this.memberFurtherSecurityDetails.phoneNumber && this.valid && !this.isSubmitting;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .member-further-security {

        &__subtitle {
            padding: 0 5px 30px;
            font-size: 16px;
        }

        &__form {
            padding-left: 5px;
            padding-bottom: 30px;
        }

        &__validation-message {
            color: $ypo-gray;
            font-size: 16px;
        }

        &__member-services-phone {
            color: $ypo-cta;
            font-size: 18px;
        }
    }

</style>
